import styled, { css } from 'styled-components'

const v4 = css`
  max-width: 100px;
  background-color: #000;
  border-radius: var(--button-border-radius);
  padding: 5px 10px;
  font-size: 10px;
  margin-bottom: 20px;
`
const Link = styled.a`
  max-width: 220px;
  text-decoration: none;
  color: #fff;
  background-color: #c74100;
  border: none;
  border-radius: 5px;
  padding: 15px;
  display: block;
  text-align: center;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 12px;

  &:hover,
  &:active {
    color: #fff;
  }
  ${props => props.version === 'v4' && v4}
`

export default Link



// WEBPACK FOOTER //
// ./src/components/Navbar/components/Link.js